import { capitalize } from 'lodash';
import { CompanyRoleEnum, RoleEnum } from 'types/user';

export const getRoleTagProps = (role?: RoleEnum | CompanyRoleEnum) => {
  switch (role) {
    case RoleEnum.ADMIN:
      return { color: 'volcano', text: 'Admin' };
    case RoleEnum.NOTARY:
      return { color: 'cyan', text: 'Notary' };

    case RoleEnum.CLIENT:
    case CompanyRoleEnum.REGULAR:
      return { color: 'purple', text: capitalize(role) };
    default:
      return {};
  }
};
